import { Component, OnInit, trigger, state, style, transition, animate, Output, EventEmitter } from '@angular/core';
import { MapService } from '../../services/map/map.service';
import { LayerMenuBlock } from '../../models/layer-menu-block.model';
import { LayerMenuItem } from '../../models/layer-menu-item.model';
import { Layer } from '../../models/layer.model';
import { Thematic } from '../../models/thematic.model';
import { Link } from '../../models/link.model';
import { Legend } from '../../models/legend.model';
declare var $;//jquery
@Component({
  selector: 'app-layer-menu',
  templateUrl: './layer-menu.component.html',
  styleUrls: ['./layer-menu.component.css']
})
export class LayerMenuComponent implements OnInit {
  /* Events Emitter's */
  @Output() private actionWithLayer = new EventEmitter<Layer[]>();
  @Output() private addThematicAC = new EventEmitter<Thematic>();
  @Output() private removeThematicAC = new EventEmitter<Thematic>();
  @Output() private closeTools = new EventEmitter<String>();
  @Output() private legendSelected = new EventEmitter<any>();
  
  private static config;
  private blocks: Array<LayerMenuBlock>;
  private arrowIconsDefault = {};
  private thematics: Array<Thematic>;
  private links: Array<Link>;
  private legends: Array<Legend>;
  private layerMenuDiv: any;
  private layersActivated = [];
  constructor(private mapService: MapService) {
    console.log("layer menu constructor");
    this.blocks = [];
    this.thematics = [];
    this.links = [];
  }

  ngOnInit() {
    console.log("layer menu init");
    this.arrowIconsDefault = {
      "glyphicon-chevron-down": true,
      "glyphicon-chevron-up": false
    };
    
    this.mapService.getConfiguration().then(data => {
      LayerMenuComponent.config = data
      this.loadInfo(data);
    });
    
    this.layerMenuDiv = $("#layerMenuDiv")[0];
  }

  private loadInfo(config: object) {
    this.blocks = this.mapService.parseTocLayerMenu(config["toc"], this.arrowIconsDefault);
    if (typeof (this.mapService.getThematics()) !== "undefined" && this.mapService.getThematics().length > 0) {
      this.thematics = this.mapService.getThematics();
    } else {
      this.thematics = this.mapService.parseThematics(config["thematic"]);
    }
    this.links = this.mapService.getLinks();
    this.legends = this.mapService.getLegend();
  }

  private toggleBlockContent(blockClicked: LayerMenuBlock) {
    if (blockClicked.desplegat) {
      blockClicked.arrowClasses["glyphicon-chevron-down"] = true;
      blockClicked.arrowClasses["glyphicon-chevron-up"] = false;
      blockClicked.desplegat = false;
    }
    else {
      blockClicked.arrowClasses["glyphicon-chevron-down"] = false;
      blockClicked.arrowClasses["glyphicon-chevron-up"] = true;
      blockClicked.desplegat = true;
    }
  }

  private toggleLayerFromMenu(block: LayerMenuBlock, menuItem: LayerMenuItem) {

    if (menuItem.visible) {
      block.capesVisibles++;
    } else {
      block.capesVisibles--;
    }
    console.log(">>>", this.mapService.getLayersBy("id", menuItem.layerId));
    let isNewLayer = true;
    let position = 0;

    for (let i = 0; i < this.layersActivated.length; i++) {
      let layer = this.layersActivated[i].layer;
      if (layer.id === menuItem.layerId) {
        isNewLayer = false;
        position = i;
        break;
      }
    }

    if (isNewLayer) {
      this.layersActivated.push({ block: block, menuItem: menuItem, layer: this.mapService.getLayersBy("id", menuItem.layerId)[0] });
    }
    else {
      this.layersActivated.splice(position, 1);
    }

    this.actionWithLayer.emit(
      this.mapService.getLayersBy("id", menuItem.layerId)
    );
  }


  /**
   * Es crida quan es fa una acció al header.
   * Mostra la informació associada al tool passat per paràmetre
   * @param {String} key of layer.
   */
  private removeThematicHandler(event: Thematic): void {

    this.removeThematicAC.emit(event);
  }

  private addThematicHandler(event: Thematic): void {

    this.addThematicAC.emit(event);
  }

  private closeToolsHandler() {
    this.closeTools.emit("layer");
  }


  public selectLegend(legend){
    this.legendSelected.emit(legend);
  }
}



// WEBPACK FOOTER //
// /usr/nexus/jenkins/workspace/enmapa-geoportal-frontend/src/app/components/layer-menu/layer-menu.component.ts